import { loggerFactory } from "src/logging";
import { NAME } from "./constants";

export const logger = loggerFactory.getLogger(NAME);
